export default __webpack_public_path__ + "static/media/Cosmo-Logo_White.306290a0.png";